
import appSettings from "@/_mixins/app-settings-mixin"
import localizedDate from "@/_components/shared/localized-date"
import loadingPane from "@/_components/shared/loading-pane"
import field from "@/_components/shared/field-display"
import scrollableContent from "@/_components/layouts/scrollable-content"
import copyable from "@/_components/shared/copyable"
import dialogCard from "@/_components/shared/dialog-card"
import localization from "@/_mixins/localization-mixin"
// import standardView from "@/_components/layouts/ui-parent-child-view"

export default {
    mixins : [appSettings,localization],
    components : {localizedDate,loadingPane,field,scrollableContent,copyable,dialogCard},
    mounted()
    {
        this.hasMounted = true;
    },
    data()
    {
        return {
            hasMounted : false,
        }
    },
    computed : {
        fillParentStyles()
        {
        
        var ret = { };
          if(this.hasMounted && this.$el)
          {
            var height = this.$el.parentNode.offsetHeight;
            ret["maxHeight"] = `${height}px`;
            ret["height"] = `${height}px`;
          }
          return ret;
        }
   
    }
}